// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import constants from "@store/constants";
import OrderInformationCard from "@store/Library/Components/OrderInformationCard";
import React, { FC, useContext } from "react";

const enum fields {
    showOrderNumber = "showOrderNumber",
    showPONumber = "showPONumber",
    showStatus = "showStatus",
    showOrderDate = "showOrderDate",
    showPlant = "showPlant",
    showRequestedDeliveryDate = "showRequestedDeliveryDate",
    showCarrier = "showCarrier",
    showDeliveryTerms = "showDeliveryTerms",
    showPaymentTerms = "showPaymentTerms",
    showTermsOfSale = "showTermsOfSale",
    showSoldTo = "showSoldTo",
    showOrderAcknowledgement = "showOrderAcknowledgement",
    showChangeIndicators = "showChangeIndicators",
}

interface Props extends WidgetProps {
    fields: {
        [fields.showOrderNumber]: boolean;
        [fields.showPONumber]: boolean;
        [fields.showStatus]: boolean;
        [fields.showOrderDate]: boolean;
        [fields.showPlant]: boolean;
        [fields.showRequestedDeliveryDate]: boolean;
        [fields.showCarrier]: boolean;
        [fields.showDeliveryTerms]: boolean;
        [fields.showPaymentTerms]: boolean;
        [fields.showTermsOfSale]: boolean;
        [fields.showSoldTo]: boolean;
        [fields.showOrderAcknowledgement]: boolean;
        [fields.showChangeIndicators]: boolean;
    };
}

export interface OrderInformationCardWidgetStyles {
    wrapper?: InjectableCss;
}

export const orderInformationCardWidgetStyles: OrderInformationCardWidgetStyles = {};

const styles = orderInformationCardWidgetStyles;

const OrderInformationCardWidget: FC<Props> = ({ fields }) => {
    const { value: order } = useContext(OrderStateContext);

    if (!order) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <OrderInformationCard
                order={order}
                showOrderNumber={fields.showOrderNumber}
                showPONumber={fields.showPONumber}
                showStatus={fields.showStatus}
                showOrderDate={fields.showOrderDate}
                showPlant={fields.showPlant}
                showRequestedDeliveryDate={fields.showRequestedDeliveryDate}
                showCarrier={fields.showCarrier}
                showDeliveryTerms={fields.showDeliveryTerms}
                showPaymentTerms={fields.showPaymentTerms}
                showTermsOfSale={fields.showTermsOfSale}
                showSoldTo={fields.showSoldTo}
                showOrderAcknowledgement={fields.showOrderAcknowledgement}
                showChangeIndicators={fields.showChangeIndicators}
            />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: OrderInformationCardWidget,
    definition: {
        displayName: "Order Information Card",
        group: constants.widgetGroup.orderInformation,
        allowedContexts: [
            constants.pageType.orderChangeRequest,
            constants.pageType.orderChangeRequestReview,
            constants.pageType.orderDetails,
        ],
        fieldDefinitions: [
            {
                name: fields.showOrderNumber,
                displayName: "Show Greif Order Number",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Contextual",
            },
            {
                name: fields.showPONumber,
                displayName: "Show PO Number",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Contextual",
            },
            {
                name: fields.showStatus,
                displayName: "Show Order Status",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Contextual",
            },
            {
                name: fields.showOrderDate,
                displayName: "Show Order Date",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Contextual",
            },
            {
                name: fields.showPlant,
                displayName: "Show Plant",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Contextual",
            },
            {
                name: fields.showRequestedDeliveryDate,
                displayName: "Show Requested Delivery Date",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Contextual",
            },
            {
                name: fields.showCarrier,
                displayName: "Show Carrier",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Contextual",
            },
            {
                name: fields.showDeliveryTerms,
                displayName: "Show Delivery Terms",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Contextual",
            },
            {
                name: fields.showPaymentTerms,
                displayName: "Show Payment Terms",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Contextual",
            },
            {
                name: fields.showTermsOfSale,
                displayName: "Show Terms of Sale",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Contextual",
            },
            {
                name: fields.showSoldTo,
                displayName: "Show Sold-To Information",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Contextual",
            },
            {
                name: fields.showOrderAcknowledgement,
                displayName: "Show Order Acknowledgement",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Contextual",
            },
            {
                name: fields.showChangeIndicators,
                displayName: "Show Order Change Indicators",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "Contextual",
            },
        ],
    },
};

export default widgetModule;
